import {Component, input, output} from '@angular/core';
import {PlanningRegion, ProgRegionItem} from "../../../../../models/planning_region.model";
import {PlanningRegionCellComponent} from "./planning-region-cell/planning-region-cell.component";
import {PlanningRegionEmptyCellComponent} from "./planning-region-empty-cell/planning-region-empty-cell.component";
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {dateUtils} from "../../../../../helpers/date.utils";
import {NgClass} from "@angular/common";

@Component({
  selector: '[app-planning-region-row]',
  standalone: true,
  imports: [
    PlanningRegionCellComponent,
    PlanningRegionEmptyCellComponent,
    NgClass
  ],
  templateUrl: './planning-region-row.component.html',
  styleUrl: './planning-region-row.component.scss'
})
export class PlanningRegionRowComponent {
  data = input.required<PlanningRegion>()
  dateValue = input.required<NgbDateStruct>()
  programmeIndex = input.required<number>()
  wednesday = input.required<string>()
  handleLoadRegionData = output<{wedn: string, loading: boolean}>()

  reloadProgrammes(): void {
    const wedn = dateUtils.formatDateStruct(dateUtils.toDate(this.dateValue()))
    this.handleLoadRegionData.emit({wedn: wedn, loading: false});
  }

  getProgrammesByScreen(screen_id: number): ProgRegionItem[] {
    return this.data().prog[this.wednesday()][screen_id] || [];
  }

}
